import Vue from 'vue';
import Vuex from 'vuex';

import user from './_user';
import home from './_home';
import topics from './_topics';
import topic from './_topic-single';
import feeds from './_feeds';
import feed from './_feed-single';
import fixture from './_fixture';
import articles from './_articles';
import article from './_article-single';
import videos from './_videos';
import video from './_video-single';
import explorer from './_explorer';
import cache from './_cache';
import history from './_history';
import pages from './_pages';
import featured from './_featured';
import weights from './_weights';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    home,
    topics,
    topic,
    feeds,
    fixture,
    feed,
    articles,
    article,
    videos,
    video,
    explorer,
    cache,
    history,
    pages,
    featured,
    weights
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
});
